// import React, { useRef } from "react";
// import Slider from "react-slick";
// import { FaStar, FaChevronLeft, FaChevronRight } from "react-icons/fa";

// const testimonials = [
//   {
//     name: "Mr. Rahul Sharma",
//     role: "Business Traveler",
//     image: "/img/testimonial/client1.jpg",
//     review:
//       "Excellent Mumbai Airport Cab service. On-time pickup, clean car, and professional driver. Highly recommended for airport transfers.",
//   },
//   {
//     name: "Miss. Priya Patel",
//     role: "Frequent Flyer",
//     image: "/img/testimonial/client2.jpg",
//     review:
//       "Very smooth airport pickup experience in Mumbai. Booking was easy and driver tracked my flight perfectly.",
//   },
//   {
//     name: "Mr. Amit Verma",
//     role: "Corporate Client",
//     image: "/img/testimonial/client3.jpg",
//     review:
//       "Reliable Mumbai Airport Cab service for business travel. Always punctual and comfortable rides.",
//   },
//   {
//     name: "Miss. Sneha Kapoor",
//     role: "Tourist",
//     image: "/img/testimonial/client4.jpg",
//     review:
//       "Safe and affordable airport taxi service in Mumbai. Driver was polite and helped with luggage.",
//   },
// ];

// const TestimonialSection = () => {
//   const sliderRef = useRef();

//   const settings = {
//     dots: true,
//     infinite: true,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     speed: 800,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     arrows: false, // we control manually
//     responsive: [
//       {
//         breakpoint: 992,
//         settings: { slidesToShow: 2 },
//       },
//       {
//         breakpoint: 768,
//         settings: { slidesToShow: 1 },
//       },
//     ],
//   };

//   return (
//     <section
//       className="-bottom testimonial-style5"
//       style={{
//         backgroundImage: "url('/images/shape/client-bg-shape.png')",
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//       }}
//     >
//       <div className="container">

//         {/* HEADER */}
//         <div className="row align-items-end mb-4">
//           <div className="col-lg-7">
//             <div className="title-area">
//               <span className="sec-subtitle">
//                 Mumbai Airport Cab Reviews
//               </span>
//               <h2 className="sec-title h1">
//                 Trusted by Thousands of Happy Customers
//               </h2>
//             </div>
//           </div>

//           {/* ARROWS */}
//           <div className="col-lg-5 text-end">
//             <button
//               className="icon-btn me-2"
//               onClick={() => sliderRef.current.slickPrev()}
//             >
//               <FaChevronLeft />
//             </button>

//             <button
//               className="icon-btn"
//               onClick={() => sliderRef.current.slickNext()}
//             >
//               <FaChevronRight />
//             </button>
//           </div>
//         </div>

//         {/* SLIDER */}
//         <Slider ref={sliderRef} {...settings}>
//           {testimonials.map((item, index) => (
//             <div key={index} className="px-3">
//               <div className="testi-style5">
//                 <div className="testi-body">

//                   {/* HEADER */}
//                   <div className="testi-header">
                   

//                     <div className="testi-client">
//                       <div style={{ color: "#ffb400" }}>
//                         {[...Array(5)].map((_, i) => (
//                           <FaStar key={i} />
//                         ))}
//                       </div>

//                       <h3 className="testi-name">{item.name}</h3>
//                       <span className="testi-degi">{item.role}</span>
//                     </div>
//                   </div>

//                   {/* REVIEW */}
//                   <p className="testi-text">{item.review}</p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </Slider>

//       </div>
//     </section>
//   );
// };

// export default TestimonialSection;


import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { FaStar } from "react-icons/fa";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const testimonials = [
  {
    name: "Mr. Rahul Sharma",
    role: "Business Traveler",
    review:
      "Excellent Mumbai Airport Cab service. On-time pickup, clean car, and professional driver. Highly recommended for airport transfers.",
  },
  {
    name: "Miss. Priya Patel",
    role: "Frequent Flyer",
    review:
      "Very smooth airport pickup experience in Mumbai. Booking was easy and driver tracked my flight perfectly.",
  },
  {
    name: "Mr. Amit Verma",
    role: "Corporate Client",
    review:
      "Reliable Mumbai Airport Cab service for business travel. Always punctual and comfortable rides.",
  },
  {
    name: "Miss. Sneha Kapoor",
    role: "Tourist",
    review:
      "Safe and affordable airport taxi service in Mumbai. Driver was polite and helped with luggage.",
  },
];

const TestimonialSection = () => {
  return (
    <section
      className="testimonial-style5"
      style={{
        backgroundImage: "url('/images/shape/client-bg-shape.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "80px 0",
      }}
    >
      <div className="container">
        {/* Header */}
        <div className="row mb-5">
          <div className="col-lg-12 text-center">
            <span className="sec-subtitle">
              Mumbai Airport Cab Reviews
            </span>

            <h2 className="sec-title h1">
              Trusted by Thousands of Happy Customers
            </h2>
          </div>
        </div>

        {/* Swiper Slider */}
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation={true}
          pagination={{ clickable: true }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}
          spaceBetween={25}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
          }}
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="testi-style5">
                <div className="testi-body">
                  <div className="testi-header">
                    <div className="testi-client">
                      <div
                        style={{
                          color: "#ffb400",
                          marginBottom: "10px",
                        }}
                      >
                        {[...Array(5)].map((_, i) => (
                          <FaStar
                            key={i}
                            style={{ marginRight: "3px" }}
                          />
                        ))}
                      </div>

                      <h3 className="testi-name">{item.name}</h3>

                      <span className="testi-degi">
                        {item.role}
                      </span>
                    </div>
                  </div>

                  <p className="testi-text">
                    {item.review}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TestimonialSection;